var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var TickRoundedIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 50,
    glyphHeight: 50
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M38.8091 0.75807C29.7083 -0.25269 20.2917 -0.25269 11.1909 0.75807C5.80231 1.35583 1.44786 5.5945 0.81646 11.007C-0.272153 20.2994 -0.272153 29.6897 0.81646 38.993C1.44786 44.4055 5.80231 48.6442 11.1909 49.2419C20.2917 50.2527 29.7083 50.2527 38.8091 49.2419C44.1977 48.6333 48.5521 44.4055 49.1835 38.993C50.2722 29.6897 50.2722 20.2994 49.1835 11.007C48.5521 5.5945 44.1977 1.35583 38.8091 0.75807ZM11.6808 5.1489C20.455 4.17074 29.5341 4.17074 38.3192 5.1489C41.6939 5.51842 44.3936 8.18118 44.7855 11.5178C45.8306 20.4733 45.8306 29.5158 44.7855 38.4714C44.3936 41.7971 41.6939 44.4598 38.3192 44.8402C29.545 45.8184 20.4659 45.8184 11.6808 44.8402C8.30612 44.4707 5.60636 41.808 5.21446 38.4714C4.16939 29.5158 4.16939 20.4733 5.21446 11.5178C5.60636 8.18118 8.30612 5.51842 11.6808 5.1489ZM21.7725 29.3419L33.3009 17.8323H33.29C34.1391 16.9846 35.5216 16.9846 36.3708 17.8323L36.5558 18.0171C37.4049 18.8648 37.4049 20.2451 36.5558 21.0928L23.3074 34.3196C22.4583 35.1674 21.0757 35.1674 20.2266 34.3196L13.5099 27.6139C12.6608 26.7661 12.6608 25.3858 13.5099 24.5381L13.695 24.3533C14.5441 23.5056 15.9266 23.5056 16.7757 24.3533L21.7725 29.3419Z",
    fill: "black"
  }));
};
export var TickRoundedIconGlyph = function (props) {
  return React.createElement(TickRoundedIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};